/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useIntl } from "react-intl";

import { useHistory } from "react-router";
import { useTheme } from "../../../../config/emotion";
import EwaButton2 from "./EwaButton/EwaButton2";
import { labellessButtonCss } from "./styles";
import { PurposedButtonProps } from "./types";

type Props = PurposedButtonProps & {
  templateId: number;
};

const OverviewButton = ({ templateId, ...props }: Props) => {
  const { formatMessage } = useIntl();
  const { push } = useHistory();
  const { colors } = useTheme();

  return (
    <EwaButton2
      data-cy="tb-overview-button"
      {...props}
      buttonColor={colors.secondaryColor}
      tooltip={formatMessage({ id: "administration.nav.overview" })}
      css={labellessButtonCss}
      iconName="table_chart"
      onClick={() => push(`/overview/${templateId}`)}
    />
  );
};

export default OverviewButton;
